import { SocialPageAttributes } from "@/types/SocialType";

export function fbUrlToGraphPicture(url: string): string {
  try {
    const parsed = new URL(url);
    const parts = parsed.pathname.split("/").filter(Boolean);
    if (parts.length === 0) throw new Error("Invalid Facebook URL");

    // Take the last part (username/page id)
    const username = parts[parts.length - 1].toLowerCase();

    return `https://graph.facebook.com/${username}/picture?type=large`;
  } catch (e) {
    return "";
  }
}

export function mapSocialToPictureUrl(
  attributes: SocialPageAttributes,
): string {
  if (attributes.provider_type === "facebook") {
    return fbUrlToGraphPicture(attributes.source);
  }
  return "";
}
